<template>
    <div class="audit-flat purchase-history">
        <section class="af-panel">
            <header class="af-header"> <span class="af-title title">O histórico de contratações está disponível a partir
                    de 20/09/2025. Para aquisições anteriores, entre em contato com nossa equipe.</span> </header>
            <div class="div-loading" v-if="loading">
                <Loading type="line" />
            </div>
            <div v-if="!loading && !(items && items.length)" class="af-body">
                <div class="af-empty">Sem registros para exibir.</div>
            </div>
            <div v-else class="af-body">
                <table class="af-table">
                    <thead>
                        <tr>
                            <th>MÓDULO</th>
                            <th>TERMO</th>
                            <th>USUÁRIO</th>
                            <th>DATA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(it, idx) in items" :key="'log_' + idx">
                            <td> <span class="af-pill title">{{ it.title || "—" }}</span> </td>
                            <td> <button class="af-chip-link" @click="openTerm(it.term)"> <i
                                        class="fa-solid fa-eye"></i> Visualizar </button> </td>
                            <td> <span class="title">{{ it.user || "—" }}</span> </td>
                            <td> <span class="af-date af-date--muted">{{ it.date }}</span> </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
        <Modal title="Termos e Condições" :width="950" :height="750" v-if="showModal('termSelected')">
            <ScrollBar :minHeight="350" :maxHeight="350"> <span v-html="termSelected"></span> </ScrollBar>
        </Modal>
    </div>
</template>
<script>

import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";

import { mapMutations, mapGetters } from "vuex";

export default
    {
        name: "PurchaseHistory",
        components: { Loading, Modal, ScrollBar },
        props: {
            items: { type: Array, default: () => [] },
            loading: { type: Boolean, default: false }
        },
        data() {
            return { termSelected: "", }
        },
        computed: {
            ...mapGetters("generic", ["showModal"]),
        },
        methods: {
            ...mapMutations("generic", ["openModal"]),
            openTerm(term) {
                this.termSelected = term;
                this.openModal("termSelected");
            }
        }
    }; </script>
<style scoped>
.audit-flat {
    --af-bg: #fff;
    --af-surface: #fff;
    --af-border: #e6e7eb;
    --af-muted: #6b7280;
    --af-primary: #0f172a;
    --af-accent: #577696;
    --af-radius-lg: 14px;
    --af-radius-md: 10px;
    --af-pad: 14px;
    --af-chip-bg: #f3f4f6;
    --af-chip-fg: #374151;
}

.af-panel {
    background: var(--af-surface);
    border: 1px solid var(--af-border);
    border-radius: var(--af-radius-lg);
    overflow: hidden;
}

.af-header {
    padding: var(--af-pad);
    border-bottom: 1px solid var(--af-border);
}

.af-title {
    margin: 0;
    font-size: 12px;
    color: var(--af-primary);
    font-weight: 500;
}

.af-body {
    padding: var(--af-pad);
}

.af-table {
    width: 100%;
    border-collapse: collapse;
}

.af-table th {
    text-align: left;
    font-size: 13px;
    color: var(--af-muted);
    font-weight: 600;
    padding: 10px;
    border-bottom: 1px solid var(--af-border);
}

.af-table td {
    padding: 10px;
    border-bottom: 1px solid var(--af-border);
    font-size: 14px;
}

.af-pill {
    background: rgba(87, 118, 150, 0.08);
    color: #1f2937;
    padding: 6px 5px;
    border-radius: 10px;
    font-weight: 500;
    border: 1px solid var(--af-border);
}

.af-date {
    font-size: 13px;
    color: #1f2937;
}

.af-date--muted {
    color: var(--af-muted);
}

.af-chip-link {
    background: #fff;
    border: 1px solid var(--af-border);
    padding: 6px 10px;
    border-radius: 8px;
    font-size: 13px;
    color: var(--af-accent);
    font-weight: 600;
    cursor: pointer;
}

.af-chip-link:hover {
    background: #f9fafb;
}

.af-badge-neutral {
    background: var(--af-chip-bg);
    color: var(--af-primary);
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    border: 1px solid var(--af-border);
    font-weight: 700;
}

.af-empty {
    color: var(--af-muted);
    border: 1px dashed var(--af-border);
    padding: 14px;
    border-radius: var(--af-radius-md);
    text-align: center;
    background: #fafafa;
}
</style>
